import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import 'animate.css'
import * as echarts from 'echarts'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 全局处理路由错误
Vue.config.errorHandler = function (err, vm, info) {
  // 忽略路由重复导航错误
  if (err.name !== 'NavigationDuplicated') {
    console.error('Error:', err, 'Info:', info)
  }
}

// 将 echarts 挂载到 Vue 原型上
Vue.prototype.$echarts = echarts

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
